<template>
  <div v-if="visible" class="loading-wrap">
    <div class="loading-box">
      <img src="@/assets/images/loading-bars.svg" />
      <div class="loading-text">{{ content }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Loading',
  data () {
    return {
      visible: false,
      content: '',
      showTips: true
    }
  },
  methods: {
    close () {
      this.visible = false
    },
    show () {
      this.visible = true
    }
  }
}
</script>
<style lang="scss" scoped>
.loading-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 1024;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(129, 82, 82, 0);
  .loading-box {
    width:294px;
    height:147px;
    background:rgba(255,255,255,1);
    box-shadow:0px 0px 16px 0px rgba(0,0,0,0.16);
    border-radius:5px;
    padding: 44px;
    text-align: center;
    .loading-text {
      margin-top: 10px;
      color:rgba(51,51,51,1);
    }
  }
}
</style>